module.exports = __webpack_public_path__ + "img/lisdat-bsp.0a5a4f2a.jpg";